import React, { ReactElement } from 'react'
import { defaultTheme } from '../../theme/index'
import { breakpoints } from '../../theme/breakpoints'
import styled from 'styled-components'

interface HyperlinkProps {
  action: (e: unknown) => void
  underlined?: boolean
  bold?: boolean
  color?: string
  disabled?: boolean
}

export const Hyperlink = (
  props: React.PropsWithChildren<HyperlinkProps>
): ReactElement => {
  const {
    action,
    underlined = true,
    bold = false,
    children,
    color,
    disabled,
  } = props

  const handleOnClick = (e) => {
    if (disabled) return
    action(e)
  }

  return (
    <ButtonWrapper
      onClick={handleOnClick}
      underlined={underlined}
      bold={bold}
      color={color}
      disabled={disabled}
    >
      {children}
    </ButtonWrapper>
  )
}

interface ButtonWrapperProps {
  underlined?: boolean
  bold?: boolean
  disabled: boolean
}

const ButtonWrapper = styled.span<ButtonWrapperProps>`
  width: fit-content;
  color: ${(p) =>
    p.disabled
      ? defaultTheme.colors.disabledButtonText
      : (p.color ?? defaultTheme.colors.link)};
  cursor: pointer;
  font-family: Roboto, serif;
  font-weight: ${(p) => (p.bold ? 'bold' : 'normal')};
  border-bottom: ${(p) =>
    p.underlined ? `1px solid ${p.color ?? defaultTheme.colors.link}` : 'none'};

  @media screen and (max-width: ${breakpoints.tablet}px) {
    align-self: flex-start;
    border-bottom: ${(p) =>
      p.underlined
        ? `1px solid ${p.color ?? defaultTheme.colors.link}`
        : 'none'};
  }

  @media print {
    display: none;
  }
`
